import {
  WizrAPIInstance
} from '../axios'
import {
  promptManagerAPIUrls, systemConfigUrls, contentFolderApiUrls,
  fileManagerAPIUrls, appManagerAPIUrls, orchestratorApiUrls, fileUrls, userManagementUrls, tenantManagement, accessManagement, rolesManagement, packageManagement, productManagement, integrationManagement, databaseManagement, featureManagement, AutotagListing, ControlroomApi,
  chatBotApi,
  autoSolveApis,
  widgetManagement,
  EnterPriseHubManagement,
  seekerApis,
  TrustforteDocumentData,
  langfuseApis,
  llmConfigUrls,
  contentManagementApiUrls,
  billingTokenUrls,
} from '../url'
import { 
  DatabaseIntegrationPayload, 
  DatabaseUpdatePayload, 
  DatabaseApiResponse,
  WebchatStaticFileResponse,
} from '../interfaces'

const createFolder = (payload: any = {}): Promise<any> => WizrAPIInstance.post(contentFolderApiUrls.createFolder, payload)

const listFolders = (type: string): Promise<any> => WizrAPIInstance.get(contentFolderApiUrls.listFolders(type))

const deleteFolder = (folderId: string): Promise<any> =>
  WizrAPIInstance.delete(contentFolderApiUrls.deleteFolder(folderId))

const deleteFilter = (filterId: string): Promise<any> =>
  WizrAPIInstance.delete(ControlroomApi.discoverDeleteFilter(filterId))

const updateFolder = (payload: any = {}): Promise<any> =>
  WizrAPIInstance.put(contentFolderApiUrls.updateFolder, payload)

const listFiles = (fileId: string): Promise<any> => WizrAPIInstance.get(fileManagerAPIUrls.listFiles(fileId))

const fetchStatusCount = (folderId: any): Promise<any> => {
  const url = fileManagerAPIUrls.uploadFilesCount(folderId)
  return WizrAPIInstance.get(url)
}

const uploadRetryFiles = (payload: any): Promise<any> => {
  const url = fileManagerAPIUrls.uploadRetryFiles
  return WizrAPIInstance.post(url, payload)
}

const updateFile = (payload: any = {}): Promise<any> =>
  WizrAPIInstance.put(fileManagerAPIUrls.updateFile, payload)


const uploadFile = (payload: any = {}, action: any = ''): Promise<any> =>
  WizrAPIInstance.post(fileUrls.uploadFile(action), payload)




const deleteFile = (fileId: string): Promise<any> => WizrAPIInstance.delete(fileManagerAPIUrls.deleteFile(fileId))

const listTemplates = (): Promise<any> => WizrAPIInstance.get(promptManagerAPIUrls.listPromptTemplates)

const listPublishedPrompts = (): Promise<any> =>
  WizrAPIInstance.get(promptManagerAPIUrls.listPromptsPublished)
const listDraftPrompts = (): Promise<any> =>
  WizrAPIInstance.get(promptManagerAPIUrls.listPromptsDraft)

const managePrompts = (payload: any): Promise<any> =>
  WizrAPIInstance.post(promptManagerAPIUrls.managePrompts, payload)

const addComments = (payload: any): Promise<any> =>
  WizrAPIInstance.post(promptManagerAPIUrls.addPromptFeedback, payload)

const listPromptHistory = (promptId: string): Promise<any> =>
  WizrAPIInstance.get(promptManagerAPIUrls.listPromptHistory(promptId))

const publishPrompt = (payload: any = {}): Promise<any> =>
  WizrAPIInstance.post(promptManagerAPIUrls.publishPrompt, payload)

const testPrompt = (payload: any): Promise<any> =>
  WizrAPIInstance.post(orchestratorApiUrls.promptChat, payload)

const listLLMModels = (): Promise<any> =>
  WizrAPIInstance.get(systemConfigUrls.getLLMModels)

const listAllLlmModelsForSettings = (): Promise<any> =>
  WizrAPIInstance.get(autoSolveApis.getAllLlmModelDetails)

const postLlmConfigCreate = (payload: any): Promise<any> =>
  WizrAPIInstance.post(llmConfigUrls.create, payload)

const postLlmConfigUpdate = (payload: any): Promise<any> =>
  WizrAPIInstance.post(llmConfigUrls.update, payload)

const deleteLlmConfigById = (id: string): Promise<any> =>
  WizrAPIInstance.delete(llmConfigUrls.delete(id))
const listVectorDb = (): Promise<any> =>
  WizrAPIInstance.get(systemConfigUrls.getVectorDb)
const listVoiceModels = (): Promise<any> =>
  WizrAPIInstance.get(systemConfigUrls.getVoiceModels)
const listVisionModels = (): Promise<any> =>
  WizrAPIInstance.get(systemConfigUrls.getVisionModels)
const listModels = (): Promise<any> =>
  WizrAPIInstance.get(systemConfigUrls.getModels)

const getPromptDetails = (promptId: string): Promise<any> =>
  WizrAPIInstance.get(promptManagerAPIUrls.getPromptDetails(promptId))

const getPromptTemplateDetails = (promptId: string): Promise<any> =>
  WizrAPIInstance.get(promptManagerAPIUrls.getPromptTemplateDetails(promptId))

const getPromptTags = (): Promise<any> => WizrAPIInstance.get(promptManagerAPIUrls.getPromptTags)

const listAppTemplates = (payload: any = {}): Promise<any> => WizrAPIInstance.post(appManagerAPIUrls.getAppTemplateDetails, payload)

const listAppPublished = (payload: any = {}): Promise<any> =>
  WizrAPIInstance.post(appManagerAPIUrls.listAppPublished, payload)
const listAppDraft = (payload: any = {}): Promise<any> =>
  WizrAPIInstance.post(appManagerAPIUrls.listAppDraft, payload)


const createApp = (payload: any): Promise<any> => WizrAPIInstance.post(appManagerAPIUrls.insertApp, payload)

const updateApp = (payload: any): Promise<any> => WizrAPIInstance.post(appManagerAPIUrls.updateApp, payload)

const updateDatabaseBlock = (payload: any): Promise<any> => WizrAPIInstance.post(appManagerAPIUrls.updateDatabaseBlock, payload)

const updateScheduleStatus = (payload: any): Promise<any> => WizrAPIInstance.post(appManagerAPIUrls.updateScheduleStatus, payload)

const publishApp = (payload: any): Promise<any> => WizrAPIInstance.post(appManagerAPIUrls.publishApp, payload)
const setAsDefault = (payload: any): Promise<any> => WizrAPIInstance.post(appManagerAPIUrls.setAsDefault, payload)
const setAsTemplate = (payload: any): Promise<any> => WizrAPIInstance.post(appManagerAPIUrls.setAsTemplate, payload)
const getAppDetails = (appId: string): Promise<any> =>
  WizrAPIInstance.get(appManagerAPIUrls.getAppDetails(appId))
const getPublishedAppDetails = (appId: string): Promise<any> =>
  WizrAPIInstance.get(appManagerAPIUrls.getPublishedAppDetails(appId))
const getAppDetailsTemplate = (appId: string): Promise<any> =>
  WizrAPIInstance.get(appManagerAPIUrls.getAppDetailsTemplate(appId))
const addCommentsApp = (payload: any): Promise<any> => WizrAPIInstance.post(appManagerAPIUrls.addAppFeedback, payload)
const exportWorkflow = (appId: string): Promise<any> => WizrAPIInstance.get(appManagerAPIUrls.exportWorkflow(appId))
const importWorkflow = (payload: any): Promise<any> => WizrAPIInstance.post(appManagerAPIUrls.importWorkflow, payload)
const deleteApp = (appId: any): Promise<any> => WizrAPIInstance.delete(appManagerAPIUrls.deleteApp(appId))
const validateDeletion = (appId: any): Promise<any> => WizrAPIInstance.get(appManagerAPIUrls.validateDeletion(appId))
const testAppTool = (payload: any): Promise<any> => WizrAPIInstance.post(orchestratorApiUrls.appChat, payload)
const listAppHistory = (appId: any, payload: any): Promise<any> => WizrAPIInstance.post(appManagerAPIUrls.listAppHistory(appId), payload)
const autosolveTestHistory = (botId: any, payload: any): Promise<any> => WizrAPIInstance.post(autoSolveApis.autosolveTestHistory(botId), payload)

const listAppVersions = (appId: string, type: string): Promise<any> => WizrAPIInstance.get(appManagerAPIUrls.listAppVersions(appId, type))
const listTemplateVersion = (appId: string): Promise<any> => WizrAPIInstance.get(appManagerAPIUrls.listTemplateVersions(appId))

const getBulkTestStatus = (appId: string, execId: any, type: any): Promise<any> => WizrAPIInstance.get(appManagerAPIUrls.bulkRunStatus(appId, execId, type))
const listRunHistory = (appId: string, payload: any): Promise<any> => WizrAPIInstance.post(appManagerAPIUrls.listRunHistory(appId), payload)
const testAppshareTool = (payload: any, appId: any): Promise<any> => WizrAPIInstance.appTestPost(appManagerAPIUrls.appShareTest(appId), payload)
const getAppShareDetails = (appId: any): Promise<any> => WizrAPIInstance.appshareget(appManagerAPIUrls.getAppShareDetails(appId))
const listTags = (): Promise<any> => WizrAPIInstance.get(systemConfigUrls.getTags)
const appShareLinkGeneration = (payload: any): Promise<any> => WizrAPIInstance.post(appManagerAPIUrls.appShareLinkGeneration, payload)
const appShareLinkValidation = (payload: any): Promise<any> => WizrAPIInstance.post(appManagerAPIUrls.appShareLinkValidation, payload)
const bulkrunStatusApp = (payload: any): Promise<any> => WizrAPIInstance.post(appManagerAPIUrls.bulkrunStatusApp, payload)
const uploadFilesusingLink = (payload: any, customHeaders?: { [key: string]: string }): Promise<any> => WizrAPIInstance.formDatapost(fileUrls.uploadFileUsingLink, payload, customHeaders)
const uploadFilesFromAppShare = (payload: any): Promise<any> => WizrAPIInstance.fileUploadInAppShare(fileUrls.uploadFileFromAppShare, payload)
const uploadFilesConfluence = (payload: any): Promise<any> => WizrAPIInstance.post(fileUrls.uploadFileConfluence, payload)
const uploadFilesSharePoint = (payload: any): Promise<any> => WizrAPIInstance.post(fileUrls.uploadFileSharePoint, payload)
const uploadFilesSlack = (payload: any): Promise<any> => WizrAPIInstance.post(fileUrls.uploadFileSlack, payload)
const uploadFilesSlackChannels = (payload: any): Promise<any> => WizrAPIInstance.post(fileUrls.uploadFileSlackChannels, payload)
const generateSASurl = (payload: any): Promise<any> => WizrAPIInstance.post(fileUrls.uploadFileSASgenration, payload)
const terminateBulkrun = (payload: any): Promise<any> => WizrAPIInstance.post(appManagerAPIUrls.bulkrunTerminateRun, payload)
const executeBulkrun = (payload: any): Promise<any> => WizrAPIInstance.post(appManagerAPIUrls.bulkrunExecuteBulkrun, payload)
const appApiIntegrate = (payload: any): Promise<any> => WizrAPIInstance.post(appManagerAPIUrls.appApiIntegate, payload)
const enableDisableUser = (payload: any): Promise<any> => WizrAPIInstance.post(userManagementUrls.enableDisableUser, payload)
const listTenantUsers = (tenantType: any): Promise<any> => WizrAPIInstance.get(userManagementUrls.listUsers(tenantType))
const emailInvite = (payload: any): Promise<any> => WizrAPIInstance.post(userManagementUrls.emailInvite, payload)
const updateUserDetails = (payload: any): Promise<any> => WizrAPIInstance.post(userManagementUrls.updateUserDeatils, payload)
const createUser = (payload: any): Promise<any> => WizrAPIInstance.post(userManagementUrls.createUser, payload)
const deleteUser = (userId: any): Promise<any> => WizrAPIInstance.delete(userManagementUrls.deleteUser(userId))
const getUserDetails = (userId: any): Promise<any> => WizrAPIInstance.get(userManagementUrls.getUserDetails(userId))
const getTenantList = (): Promise<any> => WizrAPIInstance.get(tenantManagement.listTenants)
const createTenants = (payload: any): Promise<any> => WizrAPIInstance.post(tenantManagement.createTenants, payload)
const getAccessList = (): Promise<any> => WizrAPIInstance.get(accessManagement.listAccess)
const getWorkspaceAccess = (payload: any): Promise<any> => WizrAPIInstance.post(accessManagement.workspaceAccess, payload)
const getRoleList = (): Promise<any> => WizrAPIInstance.get(rolesManagement.listRoles)
const deleteAccess = (access_id: any): Promise<any> => WizrAPIInstance.delete(accessManagement.deleteAccess(access_id))
const createRole = (payload: any): Promise<any> => WizrAPIInstance.put(rolesManagement.createRole, payload)
const updateRole = (payload: any): Promise<any> => WizrAPIInstance.post(rolesManagement.updateRole, payload)
const deleteRole = (roleId: any): Promise<any> => WizrAPIInstance.delete(rolesManagement.deleteRole(roleId))
const getTenantDetails = (): Promise<any> => WizrAPIInstance.get(tenantManagement.getTenantDetails)
const listPackages = (): Promise<any> => WizrAPIInstance.get(packageManagement.listPackages)
const listProducts = (): Promise<any> => WizrAPIInstance.get(productManagement.listProducts)
const updateProducts = (payload: any): Promise<any> => WizrAPIInstance.post(productManagement.updateProducts, payload)
const createPackage = (payload: any): Promise<any> => WizrAPIInstance.put(packageManagement.createPackages, payload)
const updatePackages = (payload: any): Promise<any> => WizrAPIInstance.post(packageManagement.updatePackages, payload)
const updateTenants = (payload: any): Promise<any> => WizrAPIInstance.post(tenantManagement.updateTenants, payload)
const deletePackages = (packageId: any): Promise<any> => WizrAPIInstance.delete(packageManagement.deletePackages(packageId))
const deleteTenants = (Id: any): Promise<any> => WizrAPIInstance.delete(tenantManagement.deleteTenant(Id))
const disableTenant = (Id: any): Promise<any> => WizrAPIInstance.post(tenantManagement.disableTenant(Id), {})
const enableTenant = (Id: any): Promise<any> => WizrAPIInstance.post(tenantManagement.enableTenant(Id), {})
const listIntegrations = (): Promise<any> => WizrAPIInstance.get(integrationManagement.listIntegrations)
const masterTenantIntegrations = (): Promise<any> => WizrAPIInstance.get(integrationManagement.masterTenantIntegrations)
const deleteIntegration = (integrationId: any): Promise<any> => WizrAPIInstance.delete(integrationManagement.deleteIntegration(integrationId))
const updateIntegration = (payload: any): Promise<any> => WizrAPIInstance.post(integrationManagement.updateIntegration, payload)
const createIntegration = (payload: any): Promise<any> => WizrAPIInstance.put(integrationManagement.createIntegration, payload)
const listAppForPackage = (payload: any): Promise<any> => WizrAPIInstance.post(packageManagement.listAppForPackage, payload)
const listAppGeneral = (payload: any): Promise<any> => WizrAPIInstance.post(packageManagement.listAppGeneral, payload)
const getFeatureSettings = (): Promise<any> => WizrAPIInstance.get(featureManagement.featureSetings)

const getBillingTokenUsageSummary = (): Promise<any> =>
  WizrAPIInstance.get(billingTokenUrls.tokenUsageSummary)

const getBillingTokenUsage = (type: string): Promise<any> =>
  WizrAPIInstance.get(billingTokenUrls.tokenUsage(type))

const getAgentsList = (): Promise<any> => WizrAPIInstance.get(appManagerAPIUrls.listAgentsInApp)

const getAutosolveDashboard = (payload: any): Promise<any> => WizrAPIInstance.post(featureManagement.homeDashboardAutosolve, payload)
const getHomeDashboardTotal = (payload: any): Promise<any> => WizrAPIInstance.post(featureManagement.homeDashboardTotal, payload)
const getAgentAssistDashboard = (payload: any): Promise<any> => WizrAPIInstance.post(featureManagement.homeDashboardAgentAssist, payload)
const getWorkflowDashboard = (payload: any): Promise<any> => WizrAPIInstance.post(featureManagement.homeDashboardWorkflow, payload)
const getCxAutosolveFilter = (): Promise<any> => WizrAPIInstance.get(featureManagement.cxAutosolveFilter)
const getCxAutosolveDownload = (payload: any): Promise<any> => WizrAPIInstance.post(featureManagement.CXAutosolveDownload, payload)
const getCxAgentAssistFilter = (): Promise<any> => WizrAPIInstance.get(featureManagement.cxAgentAssistFilter)
const getCxAgentAssistDownload = (payload: any): Promise<any> => WizrAPIInstance.post(featureManagement.cxAgentAssistDownload, payload)
const getCxAgentAssistCardDetails = (payload: any): Promise<any> => WizrAPIInstance.post(autoSolveApis.cxAgentAssistCardDetails,payload)
const getCxAutosolveFourCards = (payload: any): Promise<any> => WizrAPIInstance.post(featureManagement.CxAutosolveFourCards, payload)
const updateFetaureSettingsStatus = (payload: any): Promise<any> => WizrAPIInstance.post(featureManagement.updateStatus, payload)
const createFeatureIntegrationSettings = (payload: any): Promise<any> => WizrAPIInstance.post(featureManagement.createFeatureIntegration, payload)
const cloneAutosolveFeature = (payload: any): Promise<any> => WizrAPIInstance.post(autoSolveApis.cloneAutosolveFeature, payload)
const createGroupFolder = (payload: any, type: any): Promise<any> => WizrAPIInstance.post(featureManagement.addFolderGroup(type), payload)
const getAutoTagList = (type: any): Promise<any> => WizrAPIInstance.get(AutotagListing.listAutoTag(type))
const updateTicketType = (payload: any, type: any): Promise<any> => WizrAPIInstance.post(featureManagement.updateTicketType(type), payload)
const updateCompanyInfo = (payload: any): Promise<any> => WizrAPIInstance.post(featureManagement.updateCompanyInfo, payload)
const updatePersona = (payload: any): Promise<any> => WizrAPIInstance.post(featureManagement.updatePersona, payload)
const getFeatureAppDetails = (appId: any): Promise<any> => WizrAPIInstance.get(featureManagement.getFeatureAppDetails(appId))
const getPacakageDetails = (type: any): Promise<any> => WizrAPIInstance.get(featureManagement.getPacakageDetails(type))
const updateFeatureSettings = (payload: any): Promise<any> => WizrAPIInstance.post(featureManagement.updateFeatureSettings, payload)
const getEndPointUrl = (payload: any): Promise<any> => WizrAPIInstance.post(featureManagement.getEndPointUrl, payload)
const getTenantGroups = (Id: any): Promise<any> => WizrAPIInstance.get(tenantManagement.getTenantGroups(Id))
const saveTenantGroups = (payload: any): Promise<any> => WizrAPIInstance.put(tenantManagement.saveTenantGroups, payload)
const getGroupRowDetails = (type: any, folderId: any): Promise<any> => WizrAPIInstance.get(fileManagerAPIUrls.listRowContents(type, folderId))
const deleteGroupRowDetails = (type: any, rowId: any): Promise<any> => WizrAPIInstance.delete(fileManagerAPIUrls.deleteRowContent(type, rowId))
const deleteGroupsFaqPastTickets = (type: any, folderId: any): Promise<any> => WizrAPIInstance.delete(contentFolderApiUrls.deleteFaqPtGroup(type, folderId))
const getIntegrationToolsForTenant = (): Promise<any> => WizrAPIInstance.get(contentFolderApiUrls.getIntegrationsToolsForTenants)
const getIntegrationsForSelectedTool = (tool: any): Promise<any> => WizrAPIInstance.get(contentFolderApiUrls.getIntegrationsForTools(tool))
const listEmbeddingModels = (): Promise<any> => WizrAPIInstance.get(systemConfigUrls.getEmbeddingModels)
const importPastTickets = (payload: any): Promise<any> => WizrAPIInstance.post(contentFolderApiUrls.importPastTickets, payload)

const controlRoomApi = (payload: any): Promise<any> => WizrAPIInstance.post(ControlroomApi.pinotQuery, payload)
const controlRoomDynamicQuery = (payload: any): Promise<any> => WizrAPIInstance.post(ControlroomApi.discoverDynamicQuery, payload)
const controlRoomDiscoverScreenSaveFilter = (payload: any): Promise<any> => WizrAPIInstance.post(ControlroomApi.discoverSaveFilter, payload)
const getControlRoomDiscoverScreenSavedFilterNames = (payload: any): Promise<any> => WizrAPIInstance.post(ControlroomApi.discoverSavedFilterNames, payload)
const getControlRoomDiscoverScreenSavedFilterDetails = (payload: any): Promise<any> => WizrAPIInstance.post(ControlroomApi.discoverSavedFilterDetails, payload)
const getControlRoomDiscoverScreenDelete = (filterId: any): Promise<any> => WizrAPIInstance.delete(ControlroomApi.discoverDeleteFilter(filterId))
const getControlRoomDiscoverScreenGetColumns = (): Promise<any> => WizrAPIInstance.get(ControlroomApi.discoverGetColumns)
const getControlRoomDiscoverScreenGetColumnValuesForFilter = (payload: any): Promise<any> => WizrAPIInstance.post(ControlroomApi.getColumnValues, payload)
const getControlRoomFilterList = (): Promise<any> => WizrAPIInstance.get(ControlroomApi.discoverGetFilterList)
const getOrganizationSummaryDriverFilter = (): Promise<any> => WizrAPIInstance.get(ControlroomApi.organizationSummaryDriverFilter)
const getSupersetCredentials = (): Promise<any> => WizrAPIInstance.get(ControlroomApi.supersetCredentials)
const getSupersetLogin = (payload: any): Promise<any> => WizrAPIInstance.post(ControlroomApi.supersetLogin, payload)
const getSupersetCsrfToken = (): Promise<any> => WizrAPIInstance.get(ControlroomApi.supersetCsrfToken)
const getAlertsList = (payload: any): Promise<any> => WizrAPIInstance.post(ControlroomApi.listAlertsForControlRoom, payload)
const getReportsList = (payload: any): Promise<any> => WizrAPIInstance.post(ControlroomApi.listReportsForControlRoom, payload)
const addNewReports = (payload: any): Promise<any> => WizrAPIInstance.post(ControlroomApi.addNewReport, payload)
const getColumnValues = (payload: any): Promise<any> => WizrAPIInstance.post(ControlroomApi.getColumnValues, payload)
const getAlertDetails = (payload: any): Promise<any> => WizrAPIInstance.post(ControlroomApi.getAlertDetails, payload)
const createAlert = (payload: any): Promise<any> => WizrAPIInstance.post(ControlroomApi.createAlerts, payload)
const updateAlert = (payload: any): Promise<any> => WizrAPIInstance.post(ControlroomApi.updateAlerts, payload)
const deleteAlert = (payload: any): Promise<any> => WizrAPIInstance.post(ControlroomApi.deleteAlerts, payload)
const deleteReport = (report_id: any): Promise<any> => WizrAPIInstance.delete(ControlroomApi.deleteReports(report_id))
const getSupersetChartAPI = (chartId: any, headers: any): Promise<any> => {
  const url = ControlroomApi.supersetChartAPI(chartId);
  return WizrAPIInstance.get(url + '?' + new URLSearchParams(headers).toString());
}
const getSupersetChartData = (payload: any): Promise<any> => WizrAPIInstance.post(ControlroomApi.supersetChartData, payload)
const getSupersetChartID = (): Promise<any> => WizrAPIInstance.get(ControlroomApi.supersetChartID)
const getSupersetUrl = (): Promise<any> => WizrAPIInstance.get(ControlroomApi.supersetUrl)
const getSupersetCustomDashboardList = (): Promise<any> => WizrAPIInstance.get(ControlroomApi.supersetCustomDashboardList)
const getSubscriptionDetails = (): Promise<any> => WizrAPIInstance.get(tenantManagement.getSubscriptionDetails)
const updateTelemetry = (payload: any): Promise<any> => WizrAPIInstance.post(langfuseApis.updateTelemetry, payload)
const deleteTicketsFaqPt = (rowId: any, type: any): Promise<any> => WizrAPIInstance.delete(fileManagerAPIUrls.deleteTicketsFaqPt(rowId, type))
const testChatBot = (payload: any): Promise<any> => WizrAPIInstance.post(chatBotApi.chatBotTest, payload)
const testChatBotAdithyaBirla = (payload: any): Promise<any> => WizrAPIInstance.post(chatBotApi.chatBotTestAdithyaBirla, payload)
const appInsights = (payload: any, appType: any): Promise<any> => WizrAPIInstance.post(appManagerAPIUrls.appInsights(appType), payload)
const getBotDetails = (botId: string): Promise<any> => WizrAPIInstance.get(autoSolveApis.getBotDetails(botId))
const updateBot = (payload: any): Promise<any> => WizrAPIInstance.post(autoSolveApis.updateBot, payload)
const testBot = (payload: any): Promise<any> => WizrAPIInstance.post(autoSolveApis.testBot, payload)

const listWidgets = (): Promise<any> => WizrAPIInstance.get(widgetManagement.listWidgets)
const getToolsList = (): Promise<any> => WizrAPIInstance.get(widgetManagement.getToolsList)
const listWidgetTypes = (): Promise<any> => WizrAPIInstance.get(widgetManagement.listWidgetTypes)
const createWidget = (payload: any): Promise<any> => WizrAPIInstance.post(widgetManagement.createWidgets, payload)
const updateWidget = (payload: any): Promise<any> => WizrAPIInstance.post(widgetManagement.updateWidgets, payload)
const testWidget = (payload: any): Promise<any> => WizrAPIInstance.post(widgetManagement.testWidgets, payload)
const getwidgetObjectDetails = (bot_key: string): Promise<any> => WizrAPIInstance.get(widgetManagement.widgetObject(bot_key))
const getMcpTools = (payload: any): Promise<any> => WizrAPIInstance.post(widgetManagement.getMcpTools, payload)


const getAgentList = (tenant_feature_id: any, app_feature_id: any): Promise<any> => WizrAPIInstance.get(autoSolveApis.getAgentList(tenant_feature_id, app_feature_id))
const getAgentVersions = (agent_id: any): Promise<any> => WizrAPIInstance.get(autoSolveApis.getAgentVersions(agent_id))
const getDefaultAgent = (agent_id: any): Promise<any> => WizrAPIInstance.get(autoSolveApis.getDefaultAgent(agent_id))
const setAgentDefault = (payload: any): Promise<any> => WizrAPIInstance.post(autoSolveApis.setAgentDefault, payload)
const publishAgent = (payload: any): Promise<any> => WizrAPIInstance.post(autoSolveApis.publishAgent, payload)
const getInstallationList = (): Promise<any> => WizrAPIInstance.get(autoSolveApis.getInstallationList)
const createAgent = (payload: any): Promise<any> => WizrAPIInstance.post(autoSolveApis.createAgent, payload)
const createBot = (payload: any): Promise<any> => WizrAPIInstance.post(autoSolveApis.createBot, payload)
const updateAgentApi = (payload: any): Promise<any> => WizrAPIInstance.post(autoSolveApis.updateAgent, payload)
const deleteAgent = (payload: any): Promise<any> => WizrAPIInstance.delete(autoSolveApis.deleteAgent(payload))
const deleteWidget = (payload: any): Promise<any> => WizrAPIInstance.delete(autoSolveApis.deleteWidget(payload))
const getWidgetDetails = (tool_id: any): Promise<any> => WizrAPIInstance.get(autoSolveApis.getWidgetDetails(tool_id))
const getBotRunHistoryDetails = (botId: string): Promise<any> => WizrAPIInstance.get(autoSolveApis.getBotRunHistory(botId))
const getBotRunHistoryDetailsOfACoversation = (bot_id: any, conversationId: any): Promise<any> => WizrAPIInstance.get(autoSolveApis.getBotRunHistoryOfConversation(bot_id, conversationId))
const listAgentConversations = (payload: any): Promise<any> => WizrAPIInstance.post(autoSolveApis.getAgentAssistConversationList, payload)
const getAgentConversationDetail = (conversationId: any): Promise<any> => WizrAPIInstance.get(autoSolveApis.getAgentAssistConversationDetail(conversationId))
const listScheduler = (payload: any): Promise<any> => WizrAPIInstance.post(contentFolderApiUrls.listScheduler, payload)
// const getSchedulerHistory = (schedulerId:any): Promise<any> => WizrAPIInstance.get(contentFolderApiUrls.getSchedulerHistory(schedulerId))

const getAgentAssistFilterDetails = (): Promise<any> => WizrAPIInstance.get(autoSolveApis.getAgentAssistFilterDetails)
const generateCode = (payload: any): Promise<any> => WizrAPIInstance.post(autoSolveApis.generateCode, payload)
const getAutosolveConversations = (payload: any): Promise<any> => WizrAPIInstance.post(autoSolveApis.getAutosolveConversations, payload)
const getBotTestHistory = (botId: any, conversationId: any): Promise<any> => WizrAPIInstance.get(autoSolveApis.getBotTestHistory(botId, conversationId))
const saveFeedBackAutoSolve = (payload: any): Promise<any> => WizrAPIInstance.post(autoSolveApis.saveFeedBackAutoSolve, payload)
const getWidgetHistoryDetails = (payload: any, tool_id: any): Promise<any> => WizrAPIInstance.post(widgetManagement.widgetHistory(tool_id), payload)
const downloadCsvReport = (payload: any): Promise<any> => WizrAPIInstance.post(autoSolveApis.downloadCsvReport, payload)
const downloadCsvReportAgentAssist = (payload: any): Promise<any> => WizrAPIInstance.post(autoSolveApis.downloadCsvReportAgentAssist, payload)
const exportAutosolve = (botId: any): Promise<any> => WizrAPIInstance.get(autoSolveApis.exportAutosolve(botId))
const importAutosolve = (payload: any, flag: boolean): Promise<any> => WizrAPIInstance.post(autoSolveApis.importAutosolve(flag), payload)
const getUserMappedRoles = (role: any): Promise<any> => WizrAPIInstance.get(rolesManagement.getUserMappedRoles(role))
const createScheduler = (payload: any): Promise<any> => WizrAPIInstance.post(contentFolderApiUrls.createScheduler, payload)
const getAutoSolveMetaData = (): Promise<any> => WizrAPIInstance.get(autoSolveApis.autoSolveMetaData)

const getMasterData = (): Promise<any> => WizrAPIInstance.get(autoSolveApis.getMasterData)
const createAutoSolveFeature = (payload: any): Promise<any> => WizrAPIInstance.post(autoSolveApis.createAutoSolveFeature, payload)
const pinotQuery = (payload: any): Promise<any> => WizrAPIInstance.post(ControlroomApi.pinotQuery, payload)
const naturalLanguageQueryTranslation = (payload: any): Promise<any> => WizrAPIInstance.post(ControlroomApi.naturalLanguageQueryTranslation, payload)

const getAppId = (appId: any): Promise<any> => WizrAPIInstance.get(featureManagement.getAppId(appId))
const getBlockLevelHistory = (instanceId: any): Promise<any> => WizrAPIInstance.get(featureManagement.getBlockLevelHistory(instanceId))
const validateChannel = (payload: any, channelType: any): Promise<any> => WizrAPIInstance.post(autoSolveApis.validateChannel(channelType), payload)
const deleteScheduler = (schedulerId: string): Promise<any> => WizrAPIInstance.delete(contentFolderApiUrls.deleteScheduler(schedulerId))
const updateScheduler = (payload: any): Promise<any> => WizrAPIInstance.post(contentFolderApiUrls.updateScheduler, payload)
const getSchedulerHistory = (schedulerId: any, payload: any): Promise<any> => WizrAPIInstance.post(contentFolderApiUrls.getSchedulerHistory(schedulerId), payload)
const updateCustomField = (payload: any): Promise<any> => WizrAPIInstance.post(featureManagement.updateCustomField, payload)
const getAgentDetails = (agent_id: any): Promise<any> => WizrAPIInstance.get(autoSolveApis.getAgentDetails(agent_id))
const getAgentVersion = (agent_id: any): Promise<any> => WizrAPIInstance.get(autoSolveApis.getAgentVersion(agent_id))
const getAutoSolveBlockLevelHistory = (bot_id: any, conversation_id: any): Promise<any> => WizrAPIInstance.get(autoSolveApis.getAutoSolveBlockLevelHistory(bot_id, conversation_id))
const getllmModelDetailsForAutoSolve = (): Promise<any> => WizrAPIInstance.get(autoSolveApis.getllmModelDetails)
const fileuploadBulkrun = (payload: any): Promise<any> => WizrAPIInstance.post(autoSolveApis.fileuploadBulkrun, payload)
const autosolverunbatch = (payload: any): Promise<any> => WizrAPIInstance.post(autoSolveApis.autosolverunbatch, payload)
const sendMessageToUser = (payload: any): Promise<any> => WizrAPIInstance.post(autoSolveApis.sendmessagetouser, payload)
const acceptUserRequest = (payload: any): Promise<any> => WizrAPIInstance.post(autoSolveApis.acceptUserRequest, payload)
const chatNegotaite = (user_id: any): Promise<any> => WizrAPIInstance.get(autoSolveApis.chatnegotaite(user_id))
const notificationNegotaite = (bot_id: any): Promise<any> => WizrAPIInstance.get(autoSolveApis.notificationnegotaite(bot_id))

const getActiveEnterPriseHubList = (): Promise<any> => WizrAPIInstance.get(EnterPriseHubManagement.getActiveEnterPriseHubList)
const getExHubHistory = (payload: any): Promise<any> => WizrAPIInstance.post(EnterPriseHubManagement.getExHubHistory, payload)
const updateEnterPriseHub = (payload: any): Promise<any> => WizrAPIInstance.post(EnterPriseHubManagement.updateEnterPriseHub, payload)
const getConversationHistory = (bot_id: any, conversation_id: any): Promise<any> => WizrAPIInstance.get(autoSolveApis.getConersationHistory(bot_id, conversation_id))
const getFcaAuthToken = (): Promise<any> => WizrAPIInstance.fcaAuthToken();
const createSpecifyingCase = (body: any, token: string): Promise<any> => WizrAPIInstance.createSpecifyingCase(autoSolveApis.createSpecifyingCase, body, token)
const getRealTimeAudio = (): Promise<any> => WizrAPIInstance.get(autoSolveApis.realTimeAudio)
const customerInteractionAutosolveHistory = (payload:any): Promise<any> => WizrAPIInstance.post(autoSolveApis.customerInteractionAutosolveHistory, payload)
const getLiveAgentNotifications = (payload:any): Promise<any> => WizrAPIInstance.post(autoSolveApis.LiveAgentNotifications, payload)
const liveAgentEndCall = (payload:any): Promise<any> => WizrAPIInstance.post(autoSolveApis.LiveAgentEndCall, payload)
const customerInteractionAgentAssistHistory = (payload:any): Promise<any> => WizrAPIInstance.post(autoSolveApis.customerInteractionAgentAssistHistory, payload)
const updateactiveliveagent = (payload:any): Promise<any> => WizrAPIInstance.post(autoSolveApis.updateactiveliveagent, payload)
const removeactiveliveagent = (payload:any): Promise<any> => WizrAPIInstance.post(autoSolveApis.removeactiveliveagent, payload)

// Seeker API functions
const getCxSeekerCards = (payload: any): Promise<any> => WizrAPIInstance.post(seekerApis.getSeekerCards, payload)
const getCxSeekerHistoryList = (payload: any): Promise<any> => WizrAPIInstance.post(seekerApis.getSeekerHistoryList, payload)
const downloadCxSeekerCsv = (payload: any): Promise<any> => WizrAPIInstance.post(seekerApis.downloadSeekerCsv, payload)
const updateCxSeekerFeedback = (payload: any): Promise<any> => WizrAPIInstance.post(seekerApis.updateSeekerFeedback, payload)
const executePinotQuery = (payload: any): Promise<any> => WizrAPIInstance.post(seekerApis.pinotQueryApi, payload)

const getTrustforteList = (): Promise<any> => WizrAPIInstance.get(EnterPriseHubManagement.getTrustforteList)
const getLatestPublishedApp = (appId: any): Promise<any> => WizrAPIInstance.get(autoSolveApis.latestPublishedApp(appId))
const getTrustforteMailDocumentData = (id: string): Promise<any> => WizrAPIInstance.get(TrustforteDocumentData.trustforteMailDocumentData(id))

// Database Management API functions
const getDatabaseList = (payload: { integration_key: string }): Promise<DatabaseApiResponse> => WizrAPIInstance.post(databaseManagement.getDatabaseList, payload)
const getDatabaseSchemas = (payload: { integration_key: string; display_name: string }): Promise<DatabaseApiResponse> => WizrAPIInstance.post(databaseManagement.getDatabaseSchemas, payload)
const getDatabaseTables = (payload: { integration_key: string; display_name: string; schema: string }): Promise<DatabaseApiResponse> => WizrAPIInstance.post(databaseManagement.getDatabaseTables, payload)
const getDatabaseColumns = (payload: { integration_key: string; display_name: string; schema: string; table: string }): Promise<DatabaseApiResponse> => WizrAPIInstance.post(databaseManagement.getDatabaseColumns, payload)
const saveIntegrations = (payload: DatabaseIntegrationPayload): Promise<DatabaseApiResponse> => WizrAPIInstance.put(databaseManagement.saveIntegrations, payload as any)
const getEvalsRunStatus = (payload: any): Promise<any> => WizrAPIInstance.post(langfuseApis.evalsRunStatus, payload)
const getEvalDatasets = (type: string, agent_id: string): Promise<any> => WizrAPIInstance.get(langfuseApis.getEvalDatasets(type, agent_id))
const getEvalHistory = (type: string, agent_id: string): Promise<any> => WizrAPIInstance.get(langfuseApis.getEvalHistory(type, agent_id))
const runEvalAgent = (payload: { agent_id: string; dataset_name: string }): Promise<any> => WizrAPIInstance.post(langfuseApis.evalRunAgent, payload)
const runEvalApp = (payload: { app_id: string; dataset_name: string; id:string, dataset_id:string }): Promise<any> => WizrAPIInstance.post(langfuseApis.evalRunApp, payload)
const createEvalDataset = (payload: { name: string; app_id?: string; agent_id?: string }): Promise<any> => WizrAPIInstance.post(langfuseApis.createEvalDataset, payload)


const downloadPdfApi = (payload: any): Promise<any> => WizrAPIInstance.post(appManagerAPIUrls.pdfDownload, payload)

const getTemplateList = (payload: any): Promise<any> => WizrAPIInstance.post(EnterPriseHubManagement.getTemplateList, payload)
const fetchTemplateDetails = (payload: any): Promise<any> => WizrAPIInstance.post(EnterPriseHubManagement.fetchTemplateDetails, payload)
const uploadTemplate = (payload: any): Promise<any> => WizrAPIInstance.post(EnterPriseHubManagement.uploadTemplate, payload)
const deleteTemplate = (folderId: any, initiated_by: any, id: any): Promise<any> => WizrAPIInstance.delete(EnterPriseHubManagement.deleteTemplate(folderId, initiated_by, id))

// Fetch LLM models for Google Gemini integration
const fetchLLMModels = (apiKey: string): Promise<any> => {
  const url = process.env.REACT_APP_API_LLM_MODELS_FETCH?.replace('{api_key}', apiKey)
  if (!url) {
    throw new Error('LLM Models API endpoint not configured')
  }
  return WizrAPIInstance.get(url)
}

const getLangfuseRedirectUrl = (type: string): Promise<any> => WizrAPIInstance.get(langfuseApis.getRedirectUrl(type))

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null
}

function unwrapWebchatStaticResponse(data: unknown): WebchatStaticFileResponse {
  if (!isRecord(data)) {
    throw new Error('Invalid webchat static file response')
  }
  if (typeof data.download_url === 'string') {
    return {
      download_url: data.download_url,
      content: typeof data.content === 'string' ? data.content : '',
    }
  }
  const nested = data.data
  if (isRecord(nested) && typeof nested.download_url === 'string') {
    return {
      download_url: nested.download_url,
      content: typeof nested.content === 'string' ? nested.content : '',
    }
  }
  throw new Error('Invalid webchat static file response')
}

const fetchWebchatStaticFile = (
  fileType: string,
  webchatType: string,
): Promise<WebchatStaticFileResponse> =>
  WizrAPIInstance.get(contentManagementApiUrls.webchatStaticFiles(fileType, webchatType)).then((res) =>
    unwrapWebchatStaticResponse(res.data)
  );

export {
  createFolder,
  listFolders,
  deleteFolder,
  deleteFilter,
  updateFolder,
  listFiles,
  fetchStatusCount,
  uploadRetryFiles,
  updateFile,
  uploadFile,
  deleteFile,
  listTemplates,
  listPublishedPrompts,
  listDraftPrompts,
  managePrompts,
  addComments,
  listPromptHistory,
  publishPrompt,
  testPrompt,
  listLLMModels,
  listAllLlmModelsForSettings,
  postLlmConfigCreate,
  postLlmConfigUpdate,
  deleteLlmConfigById,
  getPromptDetails,
  listAppTemplates,
  getAppDetails,
  getPublishedAppDetails,
  createApp,
  updateApp,
  testAppTool,
  deleteApp,
  validateDeletion,
  publishApp,
  exportWorkflow,
  importWorkflow,
  listAppHistory,
  listAppVersions,
  getBulkTestStatus,
  testAppshareTool,
  listRunHistory,
  getPromptTags,
  listTags,
  getAppShareDetails,
  appShareLinkGeneration,
  appShareLinkValidation,
  bulkrunStatusApp,
  uploadFilesusingLink,
  uploadFilesFromAppShare,
  generateSASurl,
  terminateBulkrun,
  executeBulkrun,
  appApiIntegrate,
  getPromptTemplateDetails,
  getAppDetailsTemplate,
  listAppPublished,
  listAppDraft,
  enableDisableUser,
  listTenantUsers,
  updateUserDetails,
  createUser,
  deleteUser,
  getUserDetails,
  getTenantList,
  createTenants,
  getAccessList,
  getWorkspaceAccess,
  getRoleList,
  deleteAccess,
  createRole,
  updateRole,
  deleteRole,
  getTenantDetails,
  listPackages,
  listProducts,
  updateProducts,
  createPackage,
  updatePackages,
  updateTenants,
  deletePackages,
  deleteTenants,
  disableTenant,
  enableTenant,
  listVectorDb,
  listVoiceModels,
  listVisionModels,
  listModels,
  listIntegrations,
  masterTenantIntegrations,
  deleteIntegration,
  updateIntegration,
  createIntegration,
  listAppForPackage,
  listAppGeneral,
  setAsDefault,
  getFeatureSettings,
  getBillingTokenUsageSummary,
  getBillingTokenUsage,
  getAutosolveDashboard,
  getHomeDashboardTotal,
  getAgentAssistDashboard,
  getWorkflowDashboard,
  updateFetaureSettingsStatus,
  createFeatureIntegrationSettings,
  createGroupFolder,
  setAsTemplate,
  getAutoTagList,
  updateTicketType,
  updateCompanyInfo,
  updatePersona,
  getFeatureAppDetails,
  getPacakageDetails,
  updateFeatureSettings,
  getEndPointUrl,
  getTenantGroups,
  saveTenantGroups,
  getGroupRowDetails,
  deleteGroupRowDetails,
  deleteGroupsFaqPastTickets,
  getIntegrationToolsForTenant,
  getIntegrationsForSelectedTool,
  listEmbeddingModels,
  importPastTickets,
  controlRoomApi,
  controlRoomDiscoverScreenSaveFilter,
  getControlRoomDiscoverScreenSavedFilterNames,
  getControlRoomDiscoverScreenDelete,
  getSupersetLogin,
  getSupersetCsrfToken,
  getSupersetChartAPI,
  getSupersetChartData,
  getSupersetChartID,
  getSubscriptionDetails,
  updateTelemetry,
  deleteTicketsFaqPt,
  listTemplateVersion,
  testChatBot,
  testChatBotAdithyaBirla,
  appInsights,
  getBotDetails,
  updateBot,
  testBot,
  listWidgets,
  listWidgetTypes,
  createWidget,
  testWidget,
  getAgentList,
  getAgentVersions,
  getDefaultAgent,
  setAgentDefault,
  publishAgent,
  getInstallationList,
  getToolsList,
  getMcpTools,
  createAgent,
  createBot,
  updateAgentApi,
  deleteAgent,
  getWidgetDetails,
  updateWidget,
  deleteWidget,
  getBotRunHistoryDetails,
  getBotRunHistoryDetailsOfACoversation,
  listAgentConversations,
  getAgentConversationDetail,
  listScheduler,
  generateCode,
  getAutosolveConversations,
  addCommentsApp,
  getBotTestHistory,
  saveFeedBackAutoSolve,
  getWidgetHistoryDetails,
  downloadCsvReport,
  getUserMappedRoles,
  createScheduler,
  getAutoSolveMetaData,
  validateChannel,
  getMasterData,
  cloneAutosolveFeature,
  createAutoSolveFeature,
  getAgentDetails,
  getAgentVersion,
  pinotQuery,
  naturalLanguageQueryTranslation,
  getAppId,
  getAgentAssistFilterDetails,
  getBlockLevelHistory,
  downloadCsvReportAgentAssist,
  deleteScheduler,
  updateScheduler,
  getSchedulerHistory,
  uploadFilesConfluence,
  uploadFilesSlack,
  uploadFilesSlackChannels,
  getControlRoomDiscoverScreenSavedFilterDetails,
  controlRoomDynamicQuery,
  getControlRoomDiscoverScreenGetColumns,
  getControlRoomDiscoverScreenGetColumnValuesForFilter,
  getSupersetCredentials,
  updateCustomField,
  getAutoSolveBlockLevelHistory,
  getllmModelDetailsForAutoSolve,
  fileuploadBulkrun,
  autosolverunbatch,
  uploadFilesSharePoint,
  getwidgetObjectDetails,
  getActiveEnterPriseHubList,
  getExHubHistory,
  updateEnterPriseHub,
  autosolveTestHistory,
  emailInvite,
  getSupersetUrl,
  getConversationHistory,
  getSupersetCustomDashboardList,
  getControlRoomFilterList,
  sendMessageToUser,
  acceptUserRequest,
  chatNegotaite,
  notificationNegotaite,
  getFcaAuthToken,
  createSpecifyingCase,
  getRealTimeAudio,
  getOrganizationSummaryDriverFilter,
  customerInteractionAutosolveHistory,
  getCxAutosolveFilter,
  getCxAutosolveDownload,
  getCxAgentAssistFilter,
  getCxAgentAssistDownload,
  getCxAgentAssistCardDetails,
  getLiveAgentNotifications,
  liveAgentEndCall,
  customerInteractionAgentAssistHistory,
  getCxAutosolveFourCards,
  getCxSeekerCards,
  getCxSeekerHistoryList,
  downloadCxSeekerCsv,
  updateCxSeekerFeedback,
  executePinotQuery,
  getAlertsList,
  getReportsList,
  addNewReports,
  getColumnValues,
  getAlertDetails,
  createAlert,
  updateAlert,
  deleteAlert,
  deleteReport,
  getTrustforteList,
  getAgentsList,
  getLatestPublishedApp,
  getTrustforteMailDocumentData,
  getDatabaseList,
  getDatabaseSchemas,
  getDatabaseTables,
  getDatabaseColumns,
  saveIntegrations,
  updateDatabaseBlock,
  updateScheduleStatus,
  getEvalsRunStatus,
  getEvalDatasets,
  getEvalHistory,
  runEvalAgent,
  runEvalApp,
  createEvalDataset,
  downloadPdfApi,
  getTemplateList,
  fetchTemplateDetails,
  uploadTemplate,
  deleteTemplate,
  fetchLLMModels,
  getLangfuseRedirectUrl,
  updateactiveliveagent,
  removeactiveliveagent,
  exportAutosolve,
  importAutosolve,
  fetchWebchatStaticFile,
}
